import { Invitation } from '@domain/invitation';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { GET_INVITATION } from './type';

const getInvitationById = async (invitationId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/invitations/${invitationId}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetInvitation = ({
  invitationId,
  options,
}: {
  invitationId: string;
  options?: Record<string, boolean | number>;
}) => {
  return useGenericQuery<Invitation, RequestError>(
    [GET_INVITATION, invitationId],
    () => getInvitationById(invitationId),
    {
      ...options,
    }
  );
};
